/** Fraction of content width/height required as margin on each side when computing minimum zoom. */
const ZOOM_CONTENT_MARGIN_FRACTION = 0.2;

export const ZOOM_PROPS = {
    /** Hard floor for scale in zoom math; 0 allows zooming out enough to show very large boards. */
    MIN_SCALE: 0,
    MAX_SCALE: 3,

    // Alternative scaling maximums
    ZOOM_TO_FIT_MIN_SCALE_MAX: 0.8,

    /**
     * Maximum value for the minimum allowed zoom scale (most zoomed-out stop).
     * Minimum scale is min(fitRatioWithMargin, this cap).
     */
    ZOOM_MIN_SCALE_CAP: 0.4,

    ZOOM_CONTENT_MARGIN_FRACTION,

    /**
     * Width/height multiplier for the virtual rect that must fit in the viewport (1 + 2 * margin fraction).
     */
    ZOOM_CONTENT_MARGIN_DIMENSION_FACTOR: 1 + 2 * ZOOM_CONTENT_MARGIN_FRACTION,

    // Scale speed
    SCALE_SPEED_FACTOR: 0.0025,
    INTERPOLATION_FACTOR: 0.25,

    /** Pinch-to-zoom sends small per-frame deltaY; scale before getDesiredScaleFromScroll (cmd/meta zoom unchanged). */
    TRACKPAD_PINCH_STYLE_ZOOM_DELTA_MULTIPLIER: 3,

    // No longer used, but keeping them around as a reminder in case we want to bring it back
    SCALE_OUT_DELTA_LIMIT: 0.8,
    SCALE_IN_DELTA_LIMIT: 1.2,
};

export const ZOOM_MODES = {
    ZOOM_TO_FIT: 'zoom-to-fit',
};

export const ZOOM_TO_FIT_EVENT_NAME = 'zoomToFit';
